// Section Imports

import images from "../../assets/images/assets";
import CartSection from "./CartSection";

const CartPage = () => {
  return (
    <div className="bg-transparent w-full p-4 relative">
      <div className="bgtransparent">
        <CartSection />
      </div>

      {/* Decorative Blur */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute left-50 md:hidden lg:block top-20 lg:top-50 lg:-left-100 lg:w-1/2 saturate-150"
      />
    </div>
  );
};

export default CartPage;
